import React from "react";
import {useParams} from "react-router-dom";

type ErrorPageProps = {
    message?: string
}

/**
 * Used to show customized error messages (such as http 404 and 500 error) instead of the default tomcat pages.
 * This works in conjunction with apache-tomcat/conf/web.xml, which has <error-page> tags that redirect to this page.
 */
export const ErrorPage = ({message}: ErrorPageProps) => {
    const {errorCode} = useParams()
    return <div style={{
        backgroundColor: "#f3f6fb",
        padding: "115px 0 0",
        display: "flex",
        height: "100vh",
        flexDirection: "column",
        alignItems: "center",
    }}>
        <div style={{fontSize: "xx-large", fontWeight: "bold"}}>Error</div>
        {errorCode ? <div>Error Code: {errorCode}</div> : null}
        {message ? <div>Message: {message}</div> : null}
    </div>
}